import AcxMainTextField from "components/UI/AcxMainTextFieldGrid";
import React from "react";

type Props = {
    setFilter: React.Dispatch<React.SetStateAction<string>>;
    value: string;
};

const OrganizationRolesListSearch: React.FC<React.PropsWithChildren<React.PropsWithChildren<Props>>> = ({ setFilter, value }) => {

    return (
        <div
            style={{
                flexBasis: "100%",
            }}
        >
            <AcxMainTextField
                id="montageList-search"
                value={value}
                placeholderText="Search..."
                onChange={(evt: React.ChangeEvent<HTMLInputElement>) => {
                    setFilter(evt.currentTarget.value.toLowerCase())
                }
                }
            />
        </div>
    );
};

export default OrganizationRolesListSearch;
